export default __webpack_public_path__ + "static/media/ki.d7b6c8ca.svg";